import { useEffect } from "react";

import mitt from "mitt";
import { BusEventPayloads } from "Types";

const emitter = mitt<BusEventPayloads>();

export const useEmitter = () => {
  return {
    emitter,
    emit: emitter.emit,
  };
};

export const useEmitEvent = (
  name: keyof BusEventPayloads,
  event: BusEventPayloads[keyof BusEventPayloads]
) => {
  emitter.emit(name, event);
};

export const useEventBus = <K extends keyof BusEventPayloads>(
  name: K,
  handler: (event: BusEventPayloads[K]) => void
) => {
  const { emit, emitter } = useEmitter();

  const unregister = () => {
    emitter.off(name, handler);
  };

  useEffect(() => {
    emitter.on(name, handler);

    return () => {
      unregister();
    };
  }, [name, handler]);

  return { unregister, emitter, emit };
};

export const useListenEvents = (
  names: (keyof BusEventPayloads)[],
  handler: (event: any) => void
) => {
  const handlers = [];

  for (const name of names) {
    const payload = useEventBus(name, handler);

    handlers.push(payload);
  }

  return handlers;
};
